/** Wo ein Datensatz in der Oberfläche liegt (Klick auf eine Aufgabe führt zum Ort der Arbeit, EXPERIENCE §4.2). */
export function entityPath(entityType: string, entityId: string): string | null {
  switch (entityType) {
    case 'app_user':
      return `/einstellungen/firma/benutzer/${entityId}`;
    case 'order':
      return `/auftraege/${entityId}`;
    case 'quote':
      return `/angebote/${entityId}`;
    case 'return':
      return `/retouren/${entityId}`;
    case 'customer':
      return `/kunden/${entityId}`;
    case 'customer_address':
      // Story 4.25: Klärfall „Adresse nicht nach Shopware übertragen“ → Kunde, Reiter „Adressen“ (dort „Erneut versuchen“).
      return `/kunden/adresse/${entityId}`;
    case 'article':
      return `/artikel/${entityId}`;
    case 'mass_edit':
      return `/massenbearbeitungen/${entityId}`;
    case 'case':
      return `/aufgaben/klaerfaelle/${entityId}`;
    case 'document':
      return `/belege/${entityId}`;
    case 'shopware_field_area':
      return `/einstellungen/shop/shopware-felder/abdeckung/${entityId}`;
    case 'integration_credential':
      // Zugänge-Wächter (Story 1.85): Klärfall „Zugang fehlgeschlagen / läuft ab“ → Einstellungen › Zugänge.
      return '/einstellungen/schnittstellen/zugaenge';
    case 'shopware_import_run':
      // Übernahme aus Shopware (Story 5.27): Aufgabe zur Prüfung öffnet die Vorschau des Laufs.
      return `/artikel/aus-shopware/lauf/${entityId}`;
    case 'reorder_proposal':
      // Bestellvorschlag (Story 10.6): Freigabe-Aufgabe je Lieferant → Einkauf › Bestellvorschläge (gruppiert nach Lieferant).
      return '/einkauf/bestellvorschlaege';
    case 'delivery_note_batch_print':
      // Sammeldruck (Story 11.29): „… hat N Lieferscheine gedruckt“ → Versandzentrum.
      return '/versand';
    case 'example_invoice':
      return `/einstellungen/schnittstellen/beispiel-rechnungen/${entityId}`;
    default:
      return null;
  }
}
